
import Label from "components/general/Label";
import Competitor from "components/presentation/Competitor";
import { NocMemo as Noc } from "components/presentation/Noc"; 

const DressageJuries = ({ data }) => {

    const officials = data?.results?.officials?.filter(o => o?.function.functionCode?.startsWith('JUR'))?.sort((a, b) => a?.order - b?.order);

    return (
        <table className="w-50 table table-striped">
            <caption className="fw-bold"><Label data="HeaderGroundJury" /></caption>
            <thead>
                <tr>
                   <td className="fw-bold"><Label data="HeaderPosition" /></td>
                    <td className="fw-bold" colSpan={2}><Label data="HeaderName" /></td>
                </tr>
            </thead>
            <tbody className="table-striped">
                <Juries officials={officials} />
            </tbody>
        </table>
    );
}

const Juries = ({officials}) => {
    const out = officials?.map(o => {
        const isPresident = o?.extensions?.find(oe => oe?.oe_code === 'PRESIDENT')?.oe_value === 'Y';
        const president = isPresident ? <span>, <Label data="LabelPresident" /></span> : <></>
        const position  = o?.extensions?.find(e => e?.oe_code === 'JURY')?.oe_value
        return (
            <tr key={o?.official?.code}>
                <td className="text-start fw-bold">{position}</td>
                <td><Noc {...o?.official?.organisation}/></td>
                <td><div className="d-flex"><Competitor hidePicture={true}  {...o?.official} />{president}</div></td>
            </tr>
        );
        }
    ); 


    return (<>{out}</>);

}

export default DressageJuries;

